<template>
    <a-modal :open="open" title="设置" width="80%" :footer="null" @cancel="emits('update:open', false)">
        <div class="setting-box">
            <div class="aside">
                <a-button @click="current = 1" class="tab-btn" :type="current == 1 ? 'primary' : 'text'">
                    <SettingOutlined />
                    通用设置
                </a-button>
                <a-button @click="selectHotword" class="tab-btn" :type="current == 2 ? 'primary' : 'text'">
                    <TranslationOutlined />常用词汇
                </a-button>
                <template v-if="myPermission.permission == 'admin'">
                    <a-button v-for="(rule, index) in permissionRules" :key="index"
                     @click="selectItem(index)" class="tab-btn" :type="current == index + 3 ? 'primary' : 'text'">
                        <TranslationOutlined />{{ rule.label }}
                    </a-button>
                </template>
            </div>
            <div v-show="current == 1" class="section">
                <div class="setting-item">
                    <div class="setting-item-content">
                        <span class="item-name">语言设置</span>
                        <a-select class="flex1" v-model:value="selectLanguage" :options="languageOptions">
                        </a-select>
                    </div>
                </div>
                <div class="setting-item">
                    <div>文件夹</div>
                    <div class="setting-item-content">
                        <span class="item-name">文件下载默认位置</span>
                        <div class="flex1">
                            <span class="file-location">C:\Users\13810\Desktop\AI</span>
                            <a-button class="file-location-edit" type="primary">修改</a-button>
                        </div>
                    </div>
                </div>
                <div class="setting-item">
                    <div>数据设置</div>
                    <div class="setting-item-content">
                        <span @click="clearData" class="item-name cursor-pointer">清除缓存文件</span>
                    </div>
                </div>
            </div>
            <div v-show="current == 2" class="section">
                <a-textarea placeholder="输入常用词语使人工智能识别更加精准，词语之间可用逗号分隔 " :rows="10"
                    v-model:value="hortWords"></a-textarea>
                <div class="btns">
                    <a-button class="btn" @click="emits('update:open', false)">取消</a-button>
                    <a-button class="btn" type="primary" @click="saveHortWords">保存</a-button>
                </div>
            </div>

            <div v-show="current >= 3" class="section">
                <a-textarea placeholder="" :rows="10"
                    v-model:value="tipWords"></a-textarea>
                <div class="btns">
                    <a-button class="btn" @click="emits('update:open', false)">取消</a-button>
                    <a-button class="btn" type="primary" @click="saveTipWords">保存</a-button>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script setup>
import { message } from 'ant-design-vue';
import {
    SettingOutlined,
    TranslationOutlined,
} from '@ant-design/icons-vue';
import { ref, onActivated, watch, computed } from 'vue';
import { BASE_URL } from '@/config/api';
const props = defineProps({
    open: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['update:open'])
let hortWords = ref('')
const tipWords = ref('')
watch(() => props.open, (value) => {
    if (value) {
        current.value = 1
        hortWords.value = null
    }
})
const get_host_words = async () => {
    // alert('get_host_words')
    // axios get 请求到 /setting/hotword
    const response = await fetch(`${BASE_URL}/setting/hotword`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch(() => {

    });
    if (response && response.status !== 200) {
        message.error('获取常用词汇失败')
        return
    }
    const data = await response.json();
    hortWords.value = data.hotword
}

const get_tip_words = async (key) => {
    // axios get 请求到 /setting/hotword
    const response = await fetch(`${BASE_URL}/get_setting/${key}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch(() => {

    });
    if (response && response.status !== 200) {
        message.error('获取失败')
        return
    }
    const res = await response.json();
    tipWords.value = res.data
}

const selectHotword = () => {
    current.value = 2
    get_host_words()
}

const selectItem = (index) => {
    current.value = index + 3
    const key = permissionRules.value[index].key
    get_tip_words(key)
}
const permissionRules = ref([
    {
        key: 'summary_title',
        label: '会议主题'
    },
    {
        key: 'summary_words',
        label: '会议关键词'
    },
    {
        key: 'summary_content',
        label: '会议重点'
    },
    {
        key: 'summary_plan',
        label: '会议计划'
    },
])
const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}'
    return JSON.parse(permission)
})
const saveHortWords = async () => {
    // axios post 请求到 /setting/hotword
    const response = await fetch(`${BASE_URL}/setting/hotword`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            hotword: hortWords.value
        })
    }).catch(() => {

    });
    if (response)
        message.success('保存成功')
}

const saveTipWords = async () => {
    const rule = permissionRules.value[current.value - 3]
    const response = await fetch(`${BASE_URL}/set_setting/${rule.key}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            data: tipWords.value,
            activation_code: myPermission.value.code
        })
    }).catch(() => {

    });
    if (response)
        message.success('保存成功')
}

onActivated(() => {
    get_host_words()
    get_tip_words()
})



const current = ref(1)
const languageOptions = ref([
    {
        value: 'zh',
        label: '简体中文'
    },
])
const selectLanguage = ref('zh')
const clearData = () => {
    message.success('清理成功')
}
</script>
<style scoped lang="less">
.setting-box {
    display: flex;
    min-height: 340px;

    .aside {
        padding: 40px 10px;
        border-right: 1px solid #ECF1F7;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        .tab-btn {
            width: 150px;
            margin-bottom: 20px;
            text-align: left;

            img {
                height: 23px;
                margin-right: 8px;
            }
        }
    }

    .section {
        flex: 1;
        padding: 20px;

        .btns {
            text-align: center;
            padding: 30px;

            .btn {
                margin: 0 20px;
                width: 80px;
            }
        }

        .setting-item {
            border-bottom: 1px solid #ECF1F7;
            padding: 16px;

            &:last-child {
                border-bottom: none;
            }
        }

        .setting-item-content {
            display: flex;
            align-items: center;
            min-height: 50px;

            .item-name {
                width: 150px;
                font-weight: 800;
            }

            .flex1 {
                flex: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }

            .file-location {
                color: var(--primary-color);
                padding: 0 16px;
            }

            .file-location-edit {
                width: 80px;
            }

            .cursor-pointer {
                cursor: pointer;
            }
        }
    }
}
</style>